export default __webpack_public_path__ + "static/media/littlecreacher_2.b367ab1c.png";